import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  addManualLineItem,
  deleteManualLineItem,
  listManualLineItems,
  type ManualLineItem,
  type ManualLineItemInput,
} from "@/api/manualLineItems";

export const MANUAL_LINE_ITEMS_KEY = ["manual-line-items"] as const;

export function useManualLineItems(
  taskId: string | null | undefined,
  enabled = true,
) {
  return useQuery<ManualLineItem[]>({
    queryKey: [...MANUAL_LINE_ITEMS_KEY, taskId],
    queryFn: () => listManualLineItems(taskId as string),
    enabled: !!taskId && enabled,
    retry: false,
  });
}

export function useAddManualLineItem() {
  const qc = useQueryClient();
  return useMutation<
    ManualLineItem,
    unknown,
    { taskId: string; body: ManualLineItemInput }
  >({
    mutationFn: ({ taskId, body }) => addManualLineItem(taskId, body),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: [...MANUAL_LINE_ITEMS_KEY, data.taskId] });
    },
  });
}

export function useDeleteManualLineItem() {
  const qc = useQueryClient();
  return useMutation<void, unknown, { taskId: string; itemId: string }>({
    mutationFn: ({ taskId, itemId }) => deleteManualLineItem(taskId, itemId),
    onSuccess: (_void, vars) => {
      qc.invalidateQueries({ queryKey: [...MANUAL_LINE_ITEMS_KEY, vars.taskId] });
    },
  });
}
